






import { Component, Vue } from 'vue-property-decorator';
import ProjectList from '@/components/Project/ProjectList.vue';

@Component({
  components: {
    ProjectList,
  },
})
export default class Projects extends Vue {

}
